import {
    Box,
    Typography,
} from "@mui/material";
import TopBar from "../../components/topBar/TopBar";
import { useEffect, useState } from "react";
import SendRequest from "../../request/SendRequest";
import SubscriberProfileInfo from "../../components/SubscriberProfileInfo/SubscriberProfileInfo";
import PaymentMethod from "../../components/SubscriberProfileInfo/PaymentMethod";
import BillCollectionMethod from "../../components/SubscriberProfileInfo/BillCollectionMethod";
import { Tabs } from "../../components";
import Loading from "../../components/Loading/loading";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

function UserProfile() {

    const [userInfo, setUserInfo] = useState({
        canUpdateMobilePhone: false,
        canUpdateAddressInfo: false,
        mobilePhone: "",
        emailAddress: "",
        addressInfo: {
            area: "",
            secDistrict: "",
            street: "",
            court: "",
            building: "",
            block: "",
            level: "",
            flat: "",
            addressLine1: "",
            addressLine2: ""
        },
        promotionInfo: {
            sms: false,
            email: false,
            mail: false
        }
    })
    const [availableAreaSubdistricts, setAvailableAreaSubdistricts] = useState({
        area: ["不適用"],
        subdistricts: {
            不適用: ["不適用"],
            九龍: [""],
            香港: [""],
            新界: [""],
            中國: [""],
        }

    })
    const [availableBanks, setAvailableBanks] = useState([
        {
            bankName: "不適用",
            bankCode: ["012", "014"]
        }
    ])
    const [lastPaymentMethod, setLastPaymentMethod] = useState({
        paymentMethod: "",
        isPaymentMethodUpdatable: false,
    })

    const [billingDeliveryMethod, setBillingDeliveryMethod] = useState({
        billingDeliveryMethod: "",
        emailAddress: "",
        addressInfo: {
            area: "",
            secDistrict: "",
            street: "",
            court: "",
            building: "",
            block: "",
            level: "",
            flat: "",
            addressLine1: "",
            addressLine2: ""
        },
        canShowBillingDeliveryDetails: false,
        canUpdateBillingDeliveryMethod: false,
    })

    const [noEmailInProfile, setNoEmailInProfile] = useState(true);

    const [loading, setLoading] = useState(true)

    const [editProfile, setEditProfile] = useState(false);
    const [editPaymentMethod, setEditPaymentMethod] = useState(false);
    const [editBillingDeliveryMethod, setEditBillingDeliveryMethod] = useState(false);

    const [snackBar, setSnackBar] = useState({
        open: false,
        message: '',
        severity: '',
    })
    const handleSnackBarClose = () => {
        setSnackBar((prev) => ({
            ...prev,
            open: false,
        }));
    };

    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        const fetchUserInfoData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/userInfo' }).then(response => {
            if (response.status === 200) {
                setUserInfo(response.data.data)
                if (response.data.data.emailAddress && response.data.data.emailAddress !== "") {
                    setNoEmailInProfile(false)
                }
            }
        })
        const fetchLastPaymentMethodData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/lastPaymentMethod' }).then(response => {
            if (response.status === 200) {
                setLastPaymentMethod(response.data.data)
                console.log('setLastPaymentMethod', response.data.data)
            }
        })
        const fetchBillingDeliveryMethodData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/billingDeliveryMethod' }).then(response => {
            if (response.status === 200) {
                setBillingDeliveryMethod(response.data.data)
                console.log('setBillingDeliveryMethod', response.data.data)
                console.log('setBillingDeliveryMethod', JSON.stringify(response.data.data))
            }
        })
        const fetchAvailableAreaSubdistrictsData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/availableAreaSubdistricts' }).then(response => {
            if (response.status === 200) {
                console.log(response.data.data)
                setAvailableAreaSubdistricts(response.data.data)
            }
        })
        const fetchAvailableBanksData = await SendRequest.get({ url: process.env.REACT_APP_API_URL + 'subscriber/availableBanks' }).then(response => {
            if (response.status === 200) {
                setAvailableBanks(response.data.data)
            }
        })

        Promise.all([fetchUserInfoData, fetchLastPaymentMethodData, fetchBillingDeliveryMethodData, fetchAvailableAreaSubdistrictsData, fetchAvailableBanksData]).then(() => {
            setLoading(false)
        }).catch(error => {
            console.log(error)
        })
    };

    return (

        <>
            <Box textAlign="center">
                <Loading show={loading} />
                <TopBar />
                <Box sx={{ width: 500 }}>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        open={snackBar.open}
                        autoHideDuration={3000}
                        onClose={handleSnackBarClose}
                    >
                        <Alert
                            onClose={handleSnackBarClose}
                            severity={snackBar.severity}
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {snackBar.message}
                        </Alert>
                    </Snackbar>
                </Box>
                <Box display={"flex"} flexDirection={"column"} gap={"16px"} padding={{ xs: "0 8px", sm: "0 16px", md: "0 24px" }}>
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"} >
                        <Box width={"100%"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }} padding={"16px 0 16px 0"}>
                            <Typography fontSize={18} fontWeight={700} color={"rgba(67, 71, 78, 1)"} textAlign={"left"}  >訂戶資料</Typography>
                        </Box>
                    </Box>
                    {!loading &&
                        <>
                            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} >
                                <Box width={"100%"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }}>
                                    <SubscriberProfileInfo
                                        userInfoData={userInfo}
                                        availableAreaSubdistrictsData={availableAreaSubdistricts}
                                        noEmailInProfile={noEmailInProfile}
                                        editProfile={editProfile}
                                        setEditProfile={setEditProfile}
                                        setSnackBar={setSnackBar}
                                    />
                                </Box>
                            </Box>
                            <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                <Box width={"100%"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }}>
                                    <PaymentMethod
                                        userInfoData={userInfo}
                                        lastPaymentMethodData={lastPaymentMethod}
                                        availableBanksData={availableBanks}
                                        noEmailInProfile={noEmailInProfile}
                                        editProfile={editProfile}
                                        setEditProfile={setEditProfile}
                                        editPaymentMethod={editPaymentMethod}
                                        setEditPaymentMethod={setEditPaymentMethod}
                                        setSnackBar={setSnackBar}
                                    />
                                </Box>
                            </Box>
                            <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                <Box width={"100%"} sx={{ maxWidth: { xs: "100%", sm: "732px" } }}>
                                    <BillCollectionMethod
                                        billingDeliveryData={billingDeliveryMethod}
                                        availableAreaSubdistrictsData={availableAreaSubdistricts}
                                        noEmailInProfile={noEmailInProfile}
                                        editProfile={editProfile}
                                        setEditProfile={setEditProfile}
                                        editBillingDeliveryMethod={editBillingDeliveryMethod}
                                        setEditBillingDeliveryMethod={setEditBillingDeliveryMethod}
                                        setSnackBar={setSnackBar}
                                    />
                                </Box>
                            </Box>
                        </>
                    }
                </Box>
            </Box>
        </>
    )
}
export default UserProfile
